export default {
  // value: state => {
  //     return state.value;
  //   }
};
